// @ts-ignore
import { TimelineMax } from 'gsap/all';

export default TimelineMax;
